export default __webpack_public_path__ + "static/media/paydaylicense_ON.e56013e7.JPG";